export class KreditlinieStaticEntry {

    buergschaftsLinie = 0;
    hoechstBetragPercent = 0;
    jahresBeitrag = 0;

}
